module.exports = __webpack_public_path__ + "static/img/8051_phase_function_Paper_PointsHejduk_Prediction.4e87acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8051_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nz7Z
// module chunks = 0